var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAccept = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 17 14",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "New-Design-v1_02",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Moderation---List-View",
  transform: "translate(-971.000000, -408.000000)",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("g", {
  id: "Main-Container",
  transform: "translate(170.000000, 316.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-8",
  transform: "translate(802.000000, 83.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,16.2978056 L4.6528903,20.4400091 L14,10",
  id: "Checkmark"
})))))));
export { SvgAccept as ReactComponent };
export default __webpack_public_path__ + "static/media/accept.c7586ffc.svg";